import React from "react";
import {Collapse} from "@material-tailwind/react";
import {useTranslation} from "react-i18next";
import {Person} from "../../services/interface/query/person";
import * as IconsMui from "@mui/icons-material";
import IdentificationConsult from "../terms-conditions/IdentificationConsult";
import {ItemHeader, ItemInfo, ItemInfoSpouse} from "../components/ViewData";
import {getLocation} from "../../utils/personOptions";
import Licence from "./Licence";

interface Props {
    openCollapse: boolean;
    setOpenCollapse: React.Dispatch<React.SetStateAction<boolean>>;
    person?: Person;
    personSpouse?: Person;
    loadingPersonBasicData?: boolean;
}
function BasicInformation({openCollapse, setOpenCollapse, person, personSpouse, loadingPersonBasicData}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const styleIcon = 'min-w-[20px] min-h-[20px]'

    const toggleOpen = () => setOpenCollapse((cur) => !cur);

    return (
        <div className={'custom-card bg-white w-full px-4 py-4'}>
            <div className={'flex flex-col sm:flex-row w-full gap-3 items-center'}>
                <img
                    src={'/assets/images/grupo.png'}
                    className={'cursor-pointer hover:bg-gray-200 rounded-[10px] p-1'}
                    onClick={toggleOpen}
                    width={55}
                    height={55}
                    alt={'info-basic'}/>
                <div className={'flex flex-col'}>
                    <span className={'font-bold'}>{t('client')}</span>
                    <h3>{person?.names}</h3>
                </div>
                <div className={'sm:ml-auto flex flex-col sm:flex-row gap-6'}>
                    <ItemHeader loading={loadingPersonBasicData} text={person?.identification} icon={<IconsMui.FingerprintTwoTone/>}/>
                    <ItemHeader loading={loadingPersonBasicData} text={person?.nationalityDescription} icon={<IconsMui.PersonPinCircleTwoTone/>}/>
                    <ItemHeader loading={loadingPersonBasicData} text={person?.sexDescription} icon={<IconsMui.PortraitTwoTone/>}/>
                </div>
            </div>
            <Collapse open={openCollapse}>
                <div
                    className={'grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 mt-2 w-full border border-t-1 border-t-header border-transparent py-4 gap-6 overflow-x-auto'}>
                    <ItemInfo label={t('birth-place')} text={getLocation(person?.birthLocation)} icon={<IconsMui.LocationOnTwoTone
                        className={styleIcon}/>} loading={loadingPersonBasicData}/>
                    <ItemInfo label={t('birth-date')} text={person?.dateOfBirth} icon={<IconsMui.TodayTwoTone
                        className={styleIcon}/>}/>
                    {person?.deathDate &&
                        <ItemInfo
                            label={t('death-date')}
                            text={person?.deathDate}
                            icon={<IconsMui.ChurchTwoTone className={styleIcon}/>}
                            loading={loadingPersonBasicData}
                        />
                     }
                    <ItemInfo label={t('education-level')} text={person?.educationLevelDescription} icon={<IconsMui.SchoolTwoTone
                        className={styleIcon}/>} loading={loadingPersonBasicData}/>
                    <ItemInfo label={t('profession')} text={person?.professionDescription} icon={<IconsMui.EngineeringTwoTone
                        className={styleIcon}/>} loading={loadingPersonBasicData}/>
                    <ItemInfo label={t('civil-status')} text={person?.civilStatus}
                        icon={person?.civilStatus !== 'SOLTERO' ?
                            <IconsMui.FamilyRestroomTwoTone className={styleIcon}/> : <IconsMui.BoyTwoTone className={styleIcon}/>}
                              loading={loadingPersonBasicData}
                    />
                    <ItemInfo label={t('citizenship')} text={person?.citizenshipDescription} icon={<IconsMui.SouthAmericaTwoTone
                        className={styleIcon}/>} loading={loadingPersonBasicData}/>
                    <Licence {...{person, styleIcon}}/>
                </div>
                {personSpouse !== undefined &&
                    <div className={'flex flex-col sm:flex-row mt-2 w-full border border-t-1 border-t-header border-transparent pt-2 items-center'}>
                        <div className={'flex flex-col gap-2'}>
                            <div className={'flex flex-col gap-2'}>
                                <span className={'font-bold text-labelColor'}>{t('spouse')}</span>
                            </div>
                            <div className={'flex flex-row gap-6'}>
                                <div className={'gap-1 flex flex-row'}>
                                    <IconsMui.FingerprintTwoTone/>
                                    <IdentificationConsult identification={personSpouse?.identification}/>
                                </div>
                                <h3>{personSpouse?.names}</h3>
                            </div>
                        </div>
                        <div
                            className={'sm:ml-auto flex flex-col sm:flex-row pt-2 gap-6'}>
                            <ItemInfoSpouse
                                label={t('birth-place')}
                                text={getLocation(personSpouse?.birthLocation)}
                                icon={<IconsMui.LocationOnTwoTone className={styleIcon}/>}
                                loading={loadingPersonBasicData}
                            />
                            <ItemInfoSpouse
                                label={t('birth-date')}
                                text={personSpouse?.dateOfBirth}
                                icon={<IconsMui.TodayTwoTone className={styleIcon}/>}
                                loading={loadingPersonBasicData}
                            />
                        </div>
                    </div>
                }
            </Collapse>
        </div>
    )
}

export default BasicInformation
